import * as cx from 'classnames';
import { CANCEL } from 'mk/autogenerated/translations/FormControls.b217fac14ba52ca7f00c5049f28cfe54'
import { Spinner } from 'mk/common/components/Spinner';
import * as React from 'react';

interface OwnProps {
    submitText: string;
    submitClassName?: string;
    cancelText?: string;
    cancelClassName?: string;
    isSubmitting?: boolean;

    onCancel();
}

export class FormControls extends React.Component<OwnProps> {

    public render() {
        const submitClassName = this.props.submitClassName || 'g-bz-green-btn';
        const cancelClassName = this.props.cancelClassName || 'as_link';

        return (
            <div className="form-controls">
                <button
                    className={cx(submitClassName, {
                        submitting: this.props.isSubmitting,
                    })}
                    type="submit"
                    onClick={this.props.isSubmitting ? this.preventSubmit : undefined}
                >
                    <span>{this.props.submitText}</span>
                    {this.props.isSubmitting && <Spinner />}
                </button>
                {this.props.onCancel ? (
                    <button
                        className={cx(cancelClassName, {disabled: this.props.isSubmitting})}
                        type="button"
                        onClick={!this.props.isSubmitting && this.props.onCancel}
                    >
                        <span>{this.props.cancelText || CANCEL}</span>
                    </button>
                ) : null}
            </div>
        );
    }

    private preventSubmit = (event) => {
        event.preventDefault();
    };

}
